(function ($) {
    $('document').ready(function() {
        initializeFullPageLoader();
        // fancybox/lightbox
        if($("a.lightbox").length > 0) {
            $("a.lightbox").fancybox();
        }

        // wrap all tables
        $('.main-content table').wrap('<div class="scroll-horizontal"></div>');

        $('.download-image').each(function() {
            $(this).closest('.row').wrap('<div class="flyer-item"></div>')
        });

        // ScrollUp Funktion
        $.scrollUp({
            scrollText: ''
        });

        // initializeFullPageLoader();
        // initializeMobileNavigationButton($('#hamburger'), $('.mobile-nav'));
        // metaNavScroll($('.meta-nav'));
        // initializeSubmenuPosition();
        initializeDataToggle( $('.toggle-data-inner'), $('.product-data-section') );
        // mobileHover();

        $(window).resize(function() {
            initializeDataToggle( $('.toggle-data-inner'), $('.product-data-section') );
        });


        $('.carousel').carousel({
            interval: 2000,
            pause: "none"
        });
        $('.carousel').carousel('pause');


        $('#slidervideo').on('ended',function() {

            $('.carousel').carousel('cycle');
            $('.carousel').attr('data-pause','true');

        });
        if ($('.carousel').attr('data-pause') != 'true') {
            $('#startpage-carousel').hover(function(){
                $('#startpage-carousel').carousel('pause');
            }, function() {
                $('#startpage-carousel').carousel('cycle');
            });
        }

    });
})(jQuery);